import { createAction } from '@reduxjs/toolkit'
import { Invoice, Subscription } from '../models/Subscription'

export const setSubscriptions = createAction<any>('payment/setSubscriptions')
export const setSubscriptionsLoadingInProgress = createAction<boolean>(
  'payment/setSubscriptionsLoadingInProgress',
)
export const setIntentClientSecret = createAction<string>(
  'payment/setIntentClientSecret',
)
export const setPricingProduct = createAction<any>('payment/setPricingProduct')
export const setIsLoading = createAction<boolean>('payment/setIsLoading')
export const setIsPaymentProcessing = createAction<boolean>(
  'payment/setIsPaymentProcessing',
)
export const setSelectedOneTimePaymentProductName = createAction<string>(
  'payment/setSelectedOneTimePaymentProductName',
)
export const setFilePaymentStatus = createAction<any>(
  'payment/setFilePaymentStatus',
)
export const setCurrentSubscriptionPlan = createAction<Subscription>(
  'payment/setCurrentSubscriptionPlan',
)
export const setShowSubscriptionModalDialog = createAction<boolean>(
  'payment/showSubscriptionModalDialog',
)
export const setSubscriptionInvoices = createAction<Invoice[]>(
  'payment/setSubscriptionInvoices',
)
